'use client'

import { usePlayGameToMobileRedirect } from '@patrianna/shared-hooks'

import type { ReactNode } from 'react'

export function GameToMobileRedirect({ children }: { children: ReactNode }) {
  usePlayGameToMobileRedirect()

  return children
}
